import React, { useState, useRef, useEffect } from 'react';
import Nav from "../../components/Nav";
import Body from "../../components/Body";
import { DataTable, DataTableExpandedRows, DataTableRowEvent, DataTableValueArray } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { usePrefundAudits } from "../../state/sampleAuditsExceptionsState";
import { useNavigate } from "react-router-dom";
import axios, { AxiosResponse } from 'axios';
import { TabView, TabPanel, TabPanelHeaderTemplateOptions } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import ReactDomServer from 'react-dom/server';
import { Badge } from 'primereact/badge';
import { authenticatedFetch } from '../../state/apiUtils';
import useHasRole from "../../hooks/validRolesHook";
import NotFound from "../Global/404NotFound";
import Loading from "../Global/loading";
import { getTenantPath } from '../Global/TenantPath';

export default function AuditList(props: any) {
    const toast = useRef<Toast>(null);

    const navigate = useNavigate();
    const auditPlanType = props.AuditPlanType;

    const [assignableUsers, setAssignableUsers] = useState<any[]>([]);

    const [tabSummary, setTabSummary] = useState<any>(
        {
            Unassigned: 0, Reviewing: 0, Total: 0, QCComplete: 0, QCCompleteFinding: 0, Complete: 0
        }
    );

    const [selectedFindings, setSelectedFindings] = useState<any[]>([])

    const assignPriorities = [
        "High",
        "Medium",
        "Low"
    ];
    //Temporary for now since usePrefundAudits() is not working anymore
    //const {prefundStatus, prefundData, prefundError} = usePrefundAudits();

    // const onRowClick = (e: any) => {
    //     navigate(`/AuditForm/${e.data.MonthlyFundedLoanId}?audit_plan_id=${e.data.AuditPlanId}`);
    // }


    useEffect(() => {

        getAssignableUsers();
        getTabSummary();

    }, [props.AuditPlanType]);

    const issue166Flag = (item: any) => {
        toast.current?.show({ severity: 'error', summary: 'Error: Issue 166', detail: 'Issue 166 has been detected. Please report this to the developers.', life: 6000 });
    }


    const getAssignableUsers = () => {
        authenticatedFetch(
            "/Audit/GetAssignableUsers")
            .then(res => {
                var data = res;
                setAssignableUsers(data);
            });

    }

    const getTabSummary = () => {
        authenticatedFetch(
            `/Audit/Get${auditPlanType}Summary`)
            .then(res => {
                var data = res;
                setTabSummary(data);
            });

    }

    const priorityTemplate = (item: any) => {
        return (<div>
            {item.Priority} {item.PriorityOrder == 0 ? <i className="pi pi-arrow-up" style={{ color: 'red' }} /> : ""}
        </div>)
    };


    const loanTemplate = (item: any) => {
        if (item.LoanData?.LoanName === null) {
            issue166Flag(item);
            return (<div>Error: Issue 166</div>)
        }
        return (<div className="linkButton"
            //onClick={() => navigate(`/AuditView/${item.LoanData?.MonthlyFundedLoanId}?auditReviewId=${item.AuditReviewId}`)} the below code has changed for multi tenant
            onClick={() => navigate(`${getTenantPath(`AuditView/${item.LoanData?.MonthlyFundedLoanId}`)}?auditReviewId=${item.AuditReviewId}`)}
        > {item.LoanData?.LoanName}
        </div>)
    };

    const isQCAuditor = useHasRole(['QC Auditor']).hasRoles;
    // ── NEW: role checks at parent level so they are valid React hooks ──
    const isSystemAdmin = useHasRole(['System Administrator']).hasRoles;
    // ── END NEW ──

    const findingTemplate = (data: any) => {


        return (
            <div className="findingGroup" >
                <DataTable value={data.Findings} size="small" className="findingTable" dataKey="AuditFindingId" columnResizeMode="fit" scrollable


                    scrollHeight='56vh'>

                    <Column field="RecordName" header="Finding" sortable filter />
                    <Column field="DefectDetail" header="Detail" sortable filter />
                    <Column field="DefectCategory" header="Category" sortable filter />
                    <Column field="DefectSubCategory" header="Subcategory" sortable filter />
                    <Column field="DefectName" header="Defect Name" sortable filter />
                    <Column field="SeverityRating" header="Severity" sortable filter />
                    <Column field="CreatedBy" header="By" sortable filter />
                    <Column field="CreatedDate" header="Date" sortable filter />
                </DataTable>
            </div>
        );
    };

    const allowExpansion = (data: any) => {
        return data.Findings != null && data.Findings!.length > 0;
    };

    const toggleFindings: any = (state: boolean, auditData: any) => {
        if (!state) {
            return {};
            //setShowAllFindings(!showAllFindings);
        }
        else {
            let _expandedRows: any = {};

            auditData.forEach((p: any) => {
                if (p.Findings!.length > 0)
                    _expandedRows[`${p.AuditReviewId}`] = true
                //else
                //_expandedRows[`${p.AuditReviewId}`] = false
            });


            return _expandedRows;
            //setExpandedRows(_expandedRows);
            //setExpandedRows({});
            //setShowAllFindings(!showAllFindings);

        }
    }

    // const AssignAudits = (props: any) => { 

    //     const [assign, setAssign] = useState<boolean>(false);
    //     const [assignedTo, setAssignedTo] = useState<any>({
    //         userId: "",
    //         priority: "Medium"
    //     });

        

    //     const assignActions = (
    //         <div>
    //             <Button label="Cancel" icon="pi pi-times" className='smallButton p-button-text' onClick={() => setAssign(false)} />
    //             <Button label="Submit" icon="pi pi-check" className='smallButton' onClick={() => assignItems()} autoFocus />
    //         </div>
    //     );

    //     const assignItems = () => {

    //         let param = {
    //             UserId: assignedTo.userId,
    //             Priority: assignedTo.priority,
    //             AuditReviewIds: props.selectedItems.map((m:any) => m.AuditReviewId)
    //         }
    //         authenticatedFetch(
    //             "/Audit/AssignItems", {
    //             method: "POST",
    //             body: JSON.stringify(param),
    //             headers: {
    //                 "Content-Type": "application/json",
    //             }
    //         })
    //             .then(res => {
    //                 var data = res;
    //                 //refresh data
    //                 props.onSubmit();
                    
    //                 setAssign(false);
    //                 toast.current?.show({ severity: 'success', summary: 'Confirmed', detail: 'Items has been successfully assigned', life: 3000 });

    //             });
    //     }

    //     function assignLabel() { 
    //         if (props.new) {
    //             return "Assign";
    //         }
    //         else 
    //         {
    //             return "Re-assign"; 
    //         }
    //     }
    //     return (
    //         <>
    //         <Button className='smallButton' disabled={props.selectedItems.length == 0} onClick={() => setAssign(true)}>{assignLabel()} Item(s)</Button>

    //             <Dialog header="QC Auditor Assignment" visible={assign} style={{ width: '400px' }} onHide={() => setAssign(false)} footer={assignActions}>
    //                 <div className="mt-2 grid">
    //                     <div className="col-12 mb-2">
    //                         <label className="block mb-2 text-x">{assignLabel()} Item(s) to </label>
    //                         <Dropdown value={assignedTo.userId} onChange={(e) => setAssignedTo((s: any) => { return { ...s, userId: e.value } })} optionLabel='FullName' optionValue='UserId' options={assignableUsers}
    //                             className="w-full" />
    //                     </div>
    //                     <div className="col-12 mb-2">
    //                         <label className="block mb-2 text-x">Priority</label>
    //                         <Dropdown value={assignedTo.priority} onChange={(e) => setAssignedTo((s: any) => { return { ...s, priority: e.value } })} options={assignPriorities}
    //                             className="w-full" />
    //                     </div>
    //                 </div>
    //             </Dialog>
    //         </>
    //     )

    // }
        // ── ONLY AssignAudits is changed below. Every other component is untouched. ──
//     const AssignAudits = (props: any) => {

//     const [assign, setAssign] = useState<boolean>(false);
//     const [assignedTo, setAssignedTo] = useState<any>({
//         userId: "",
//         priority: "Medium"
//     });
//     const [filteredUsers, setFilteredUsers] = useState<any[]>([]);

//     // Get the loan's bank from LoanData.Client e.g. "CA USA - Bank"
//     const getLoanBankName = (): string => {
//         return props.selectedItems[0]?.LoanData?.Client ?? "";
//     };

//     // Get unique bank values from all selected loans
//     const getUniqueSelectedBanks = (): string[] => {
//         const banks = props.selectedItems
//             .map((item: any) => item.LoanData?.Client ?? "")
//             .filter((b: string) => b !== "");
//         return banks.filter((b: string, i: number) => banks.indexOf(b) === i);
//     };

//     // ── STEP 1: Called when Assign button clicked ──
//     const handleOpenAssign = () => {

//         // Block if multiple loans from different banks
//         if (props.selectedItems.length > 1) {
//             const uniqueBanks = getUniqueSelectedBanks();
//             if (uniqueBanks.length > 1) {
//                 toast.current?.show({
//                     severity: 'error',
//                     summary: 'Invalid Loan Selection',
//                     detail: 'Selected loans belong to different Client Banks. Please select loans from the same Client Bank.',
//                     life: 5000
//                 });
//                 return; // block — don't fetch users or open dialog
//             }
//         }

//         // Fetch filtered users THEN open dialog
//         fetchFilteredUsers();
//     };

//     // ── STEP 2: Fetch users filtered by selected loan's client bank ──
//     const fetchFilteredUsers = () => {
//         const loanBank = getLoanBankName();

//         // Pass client bank to backend so it returns only matching users + System Admins
//         const url = loanBank
//             ? `/Audit/GetAssignableUsers?client=${encodeURIComponent(loanBank)}`
//             : `/Audit/GetAssignableUsers`;

//         authenticatedFetch(url).then((res: any[]) => {
//             console.log("fetchFilteredUsers result:", res);
//             console.log("loanBank sent:", loanBank);

//             if (isSystemAdmin && loanBank) {
//                 // System Admin: further filter on frontend
//                 // Show only users whose ClientBankName matches loan bank OR are System Admins
//                 const filtered = res.filter((u: any) =>
//                     u.RoleName === 'System Administrator' ||
//                     u.ClientBankName === loanBank
//                 );
//                 setFilteredUsers(filtered.length > 0 ? filtered : res);
//             } else {
//                 // Non-System Admin:
//                 // Backend already returned correct filtered list — use as-is
//                 setFilteredUsers(res);
//             }

//             setAssign(true); // open dialog only after users are loaded
//         });
//     };

//     // ── STEP 3: Validate on submit — block wrong bank user ──
//     const handleSubmit = () => {
//         if (!assignedTo.userId) {
//             toast.current?.show({
//                 severity: 'warn',
//                 summary: 'No User Selected',
//                 detail: 'Please select a user to assign.',
//                 life: 3000
//             });
//             return;
//         }

//         const loanBank = getLoanBankName();
//         // Find selected user from the full unfiltered assignableUsers list
//         const selectedUser = filteredUsers.find((u: any) => u.UserId === assignedTo.userId);

//         console.log("handleSubmit → loanBank:", loanBank);
//         console.log("handleSubmit → selectedUser:", selectedUser);

//         if (selectedUser && loanBank) {
//             const userIsSystemAdmin = selectedUser.RoleName === 'System Administrator';
//             const bankMatches = selectedUser.ClientBankName === loanBank;

//             console.log("userIsSystemAdmin:", userIsSystemAdmin, "| bankMatches:", bankMatches);

//             // Block if user is NOT System Admin AND bank doesn't match loan bank
//             if (!userIsSystemAdmin && !bankMatches) {
//                 toast.current?.show({
//                     severity: 'error',
//                     summary: 'Invalid User Selected',
//                     detail: 'You have selected the wrong user. Please select a valid user from the same Client Bank.',
//                     life: 5000
//                 });
//                 return; // block submit
//             }
//         }

//         assignItems(); // all validations passed → submit
//     };

//     const assignActions = (
//         <div>
//             <Button label="Cancel" icon="pi pi-times" className='smallButton p-button-text' onClick={() => setAssign(false)} />
//             <Button label="Submit" icon="pi pi-check" className='smallButton' onClick={() => handleSubmit()} autoFocus />
//         </div>
//     );

//     const assignItems = () => {
//         let param = {
//             UserId: assignedTo.userId,
//             Priority: assignedTo.priority,
//             AuditReviewIds: props.selectedItems.map((m: any) => m.AuditReviewId)
//         }
//         authenticatedFetch("/Audit/AssignItems", {
//             method: "POST",
//             body: JSON.stringify(param),
//             headers: { "Content-Type": "application/json" }
//         }).then(res => {
//             props.onSubmit();
//             setAssign(false);
//             setAssignedTo({ userId: "", priority: "Medium" }); // reset
//             setFilteredUsers([]);
//             toast.current?.show({ severity: 'success', summary: 'Confirmed', detail: 'Items has been successfully assigned', life: 3000 });
//         });
//     }

//     function assignLabel() {
//         if (props.new) return "Assign";
//         else return "Re-assign";
//     }

//     return (
//         <>
//             <Button
//                 className='smallButton'
//                 disabled={props.selectedItems.length == 0}
//                 onClick={() => handleOpenAssign()}
//             >
//                 {assignLabel()} Item(s)
//             </Button>

//             <Dialog header="QC Auditor Assignment" visible={assign} style={{ width: '400px' }} onHide={() => { setAssign(false); setFilteredUsers([]); }} footer={assignActions}>
//                 <div className="mt-2 grid">
//                     <div className="col-12 mb-2">
//                         <label className="block mb-2 text-x">{assignLabel()} Item(s) to</label>
//                         <Dropdown
//                             value={assignedTo.userId}
//                             onChange={(e) => setAssignedTo((s: any) => { return { ...s, userId: e.value } })}
//                             optionLabel='FullName'
//                             optionValue='UserId'
//                             options={filteredUsers}
//                             className="w-full"
//                             filter
//                             emptyMessage="No users available for selected loan's Client Bank"
//                         />
//                     </div>
//                     <div className="col-12 mb-2">
//                         <label className="block mb-2 text-x">Priority</label>
//                         <Dropdown
//                             value={assignedTo.priority}
//                             onChange={(e) => setAssignedTo((s: any) => { return { ...s, priority: e.value } })}
//                             options={assignPriorities}
//                             className="w-full"
//                         />
//                     </div>
//                 </div>
//             </Dialog>
//         </>
//     )
// }

const AssignAudits = (props: any) => {

    const [assign, setAssign] = useState<boolean>(false);
    const [assignedTo, setAssignedTo] = useState<any>({
        userId: "",
        priority: "Medium"
    });
    const [filteredUsers, setFilteredUsers] = useState<any[]>([]);

    // Get loan bank
    const getLoanBankName = (): string => {
        return props.selectedItems[0]?.LoanData?.Client ?? "";
    };

    // Get unique banks
    const getUniqueSelectedBanks = (): string[] => {
        const banks = props.selectedItems
            .map((item: any) => item.LoanData?.Client ?? "")
            .filter((b: string) => b !== "");
        return banks.filter((b: string, i: number) => banks.indexOf(b) === i);
    };

    // STEP 1: Open Assign
    const handleOpenAssign = () => {

        if (props.selectedItems.length > 1) {
            const uniqueBanks = getUniqueSelectedBanks();
            if (uniqueBanks.length > 1) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Invalid Loan Selection',
                    detail: 'Selected loans belong to different Client Banks. Please select loans from the same Client Bank.',
                    life: 5000
                });
                return;
            }
        }

        fetchFilteredUsers();
    };

    // STEP 2: Fetch + Filter Users (MAIN LOGIC)
    // const fetchFilteredUsers = () => {

    //     const loanBank = (getLoanBankName() || "").trim().toLowerCase();

    //     authenticatedFetch("/Audit/GetAssignableUsers")
    //         .then((res: any[]) => {

    //             console.log("All Users:", res);
    //             console.log("Loan Bank:", loanBank);

    //             let filtered: any[] = [];

    //             if (isSystemAdmin) {
    //                 // ✅ System Admin:
    //                 // Bank users + ALL System Admins
    //                 filtered = res.filter((u: any) => {
    //                     const role = (u.RoleName || "").trim().toLowerCase();
    //                     const bank = (u.ClientBankName || "").trim().toLowerCase();

    //                     const isSA = role === "system administrator";
    //                     const bankMatch = bank === loanBank;

    //                     return isSA || bankMatch;
    //                 });

    //             } else {
    //                 // ✅ Normal User:
    //                 // Only same bank users
    //                 filtered = res.filter((u: any) => {
    //                     const bank = (u.ClientBankName || "").trim().toLowerCase();
    //                     return bank === loanBank;
    //                 });
    //             }

    //             console.log("Filtered Users:", filtered);

    //             setFilteredUsers(filtered);
    //             setAssign(true);
    //         });
    // };

    const fetchFilteredUsers = () => {

    const loanBank = (getLoanBankName() || "").trim().toLowerCase();

    authenticatedFetch("/Audit/GetAssignableUsers")
        .then((res: any[]) => {

            console.log("All Users:", res);
            console.log("Loan Bank:", loanBank);

            // ✅ COMMON LOGIC FOR ALL USERS
            const filtered = res.filter((u: any) => {
                const role = (u.RoleName || "").trim().toLowerCase();
                const bank = (u.ClientBankName || "").trim().toLowerCase();

                const isSA = role === "system administrator";
                const bankMatch = bank === loanBank;

                return isSA || bankMatch;
            });

            console.log("Filtered Users:", filtered);

            setFilteredUsers(filtered);
            setAssign(true);
        });
};

    // STEP 3: Submit Validation
    const handleSubmit = () => {

        if (!assignedTo.userId) {
            toast.current?.show({
                severity: 'warn',
                summary: 'No User Selected',
                detail: 'Please select a user to assign.',
                life: 3000
            });
            return;
        }

        const loanBank = (getLoanBankName() || "").trim().toLowerCase();
        const selectedUser = filteredUsers.find((u: any) => u.UserId === assignedTo.userId);

        console.log("Selected User:", selectedUser);

        if (selectedUser && loanBank) {

            const userIsSystemAdmin = (selectedUser.RoleName || "").toLowerCase() === 'system administrator';
            const bankMatches = (selectedUser.ClientBankName || "").toLowerCase() === loanBank;

            if (!userIsSystemAdmin && !bankMatches) {
                toast.current?.show({
                    severity: 'error',
                    summary: 'Invalid User Selected',
                    detail: 'Please select a valid user from the same Client Bank.',
                    life: 5000
                });
                return;
            }
        }

        assignItems();
    };

    const assignActions = (
        <div>
            <Button label="Cancel" icon="pi pi-times" className='smallButton p-button-text' onClick={() => setAssign(false)} />
            <Button label="Submit" icon="pi pi-check" className='smallButton' onClick={() => handleSubmit()} autoFocus />
        </div>
    );

    const assignItems = () => {
        let param = {
            UserId: assignedTo.userId,
            Priority: assignedTo.priority,
            AuditReviewIds: props.selectedItems.map((m: any) => m.AuditReviewId)
        };

        authenticatedFetch("/Audit/AssignItems", {
            method: "POST",
            body: JSON.stringify(param),
            headers: { "Content-Type": "application/json" }
        }).then(res => {
            props.onSubmit();
            setAssign(false);
            setAssignedTo({ userId: "", priority: "Medium" });
            setFilteredUsers([]);

            toast.current?.show({
                severity: 'success',
                summary: 'Confirmed',
                detail: 'Items has been successfully assigned',
                life: 3000
            });
        });
    };

    function assignLabel() {
        return props.new ? "Assign" : "Re-assign";
    }

    return (
        <>
            <Button
                className='smallButton'
                disabled={props.selectedItems.length === 0}
                onClick={() => handleOpenAssign()}
            >
                {assignLabel()} Item(s)
            </Button>

            <Dialog
                header="QC Auditor Assignment"
                visible={assign}
                style={{ width: '400px' }}
                onHide={() => { setAssign(false); setFilteredUsers([]); }}
                footer={assignActions}
            >
                <div className="mt-2 grid">
                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">
                            {assignLabel()} Item(s) to
                        </label>

                        <Dropdown
                            value={assignedTo.userId}
                            onChange={(e) =>
                                setAssignedTo((s: any) => ({ ...s, userId: e.value }))
                            }
                            optionLabel='FullName'
                            optionValue='UserId'
                            options={filteredUsers}
                            className="w-full"
                            filter
                            emptyMessage="No users available for selected Client Bank"
                        />
                    </div>

                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Priority</label>

                        <Dropdown
                            value={assignedTo.priority}
                            onChange={(e) =>
                                setAssignedTo((s: any) => ({ ...s, priority: e.value }))
                            }
                            options={assignPriorities}
                            className="w-full"
                        />
                    </div>
                </div>
            </Dialog>
        </>
    );
};
    const ReviewingAudits = () => {
        const [loading, setLoading] = useState(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

        useEffect(() => {

            getAuditData();

        }, []);

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetReviewing${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);
                    let _expandedRows: any = {};
                    setExpandedRows(_expandedRows);
                });

        }

        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);

        const onAssign = () => { 
            getAuditData();
            setSelectedItems([]);
        }
        
        const QCAuditorHeader = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">
                 
                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />
            </div>
        )
        const header = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">
                <AssignAudits selectedItems={selectedItems} onSubmit={onAssign} />

                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />
            </div>
        );

        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header} alwaysShowPaginator={false}

                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} sortable filter />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Date Assigned" sortable filter />
                    <Column field="QC_StartDate" header="Date Started" sortable filter />
                    {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                         {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );


    }


    const QCCompletedAudits = () => {
        const [loading, setLoading] = useState(false);
        const [showConfirm, setShowConfirm] = useState<boolean>(false);

        useEffect(() => {

            getAuditData();

        }, []);

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetQCCompleted${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);

                });

        }
        const completeItems = () => {

            let param = {

                AuditReviewIds: selectedItems.map(m => m.AuditReviewId)
            }
            authenticatedFetch(
                "/Audit/SetComplete", {
                method: "POST",
                body: JSON.stringify(param),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(res => {
                    var data = res;
                    //refresh data
                    getAuditData();
                    setShowConfirm(false);
                    setSelectedItems([]);
                    getTabSummary();
                    toast.current?.show({ severity: 'success', summary: 'Confirmed', detail: 'Items has been successfully set to Completed', life: 3000 });

                });
        }

        const completeActions = (
            <div>
                <Button label="Cancel" icon="pi pi-times" onClick={() => setShowConfirm(false)} className="p-button-text" />
                <Button label="OK" icon="pi pi-check" onClick={() => completeItems()} autoFocus />
            </div>
        );

        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);
        const QCAuditorHeader = (
            <div className="table-header">
            </div>
        )
        const header = (
            <div className="table-header">
                <Button className='smallButton' disabled={selectedItems.length == 0} onClick={() => setShowConfirm(true)}>Set Selected Records to Completed</Button>
                <Dialog header="Complete Items" visible={showConfirm} style={{ width: '400px' }} onHide={() => setShowConfirm(false)} footer={completeActions}>

                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Do you want to set selected audit plans to complete? </label>
                    </div>
                </Dialog>
            </div>
        );

        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header} alwaysShowPaginator={false}

                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Assigned" sortable filter />
                    <Column field="QC_StartDate" header="QC Started" sortable filter />
                    <Column field="QC_CompleteDate" header="QC Completed" sortable filter />
                    {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                         {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );


    }


    const QCCompletedFindingAudits = () => {
        const [loading, setLoading] = useState(false);
        const [showConfirm, setShowConfirm] = useState<boolean>(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

        useEffect(() => {

            getAuditData();

        }, []);

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetQCCompletedFinding${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);
                });

        }

        const completeItems = () => {

            let param = {

                AuditReviewIds: selectedItems.map(m => m.AuditReviewId)
            }
            authenticatedFetch(
                "/Audit/SetComplete", {
                method: "POST",
                body: JSON.stringify(param),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(res => {
                    var data = res;
                    //refresh data
                    getAuditData();
                    setShowConfirm(false);
                    setSelectedItems([]);
                    getTabSummary();
                    toast.current?.show({ severity: 'success', summary: 'Confirmed', detail: 'Items has been successfully set to Completed', life: 3000 });
                });
        }
        const assignActions = (
            <div>
                <Button label="Cancel" icon="pi pi-times" onClick={() => setShowConfirm(false)} className="p-button-text" />
                <Button label="OK" icon="pi pi-check" onClick={() => completeItems()} autoFocus />
            </div>
        );
        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);
        const QCAuditorHeader = (
            <div className="table-header">

            </div>
        )
        const header = (
            <div className="table-header">
                <Button className='smallButton' disabled={selectedItems.length == 0} onClick={() => setShowConfirm(true)}>Set Selected Records to Completed</Button>
                <Dialog header="Complete Items" visible={showConfirm} style={{ width: '400px' }} onHide={() => setShowConfirm(false)} footer={assignActions}>

                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Do you want to set selected records to complete? </label>
                    </div>
                </Dialog>
            </div>
        );


        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header} alwaysShowPaginator={false}
                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Assigned" sortable filter />
                    <Column field="QC_StartDate" header="QC Started" sortable filter />
                    <Column field="QC_CompleteDate" header="QC Completed" sortable filter />
                      {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                         {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );


    }


    const UnassignedAudits = () => {

        const [auditData, setAuditData] = useState<any[]>([]);
        const [loading, setLoading] = useState(true);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);

        const [pageData, setPageData] = useState<any>(
            {
                pageSize: 20, index: 0, auditPlanType: auditPlanType
            }
        );


        useEffect(() => {
            getAuditData();
        }, [pageData]);

        const getAuditData = () => {

            var param = pageData;
            authenticatedFetch(
                `/Audit/GetOpen${auditPlanType}Audits`, {
                method: "POST",
                body: JSON.stringify(param),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(res => {
                    var data = res;
                    setAuditData(data);
                    setLoading(false);
                });

        }


        const onPage = (event: any) => {
            var param: any = {
                index: event.first,
                pageSize: event.rows,
                auditPlanType: auditPlanType
            }
            setPageData(param);
        };


        const onAssign = () => { 
            getAuditData();
            setSelectedItems([]);
            getTabSummary();
        }
        
        

        const QCAuditorHeader = (
            <div className="table-header">
            </div>
        )

        const header = (
            <div className="table-header">
                <AssignAudits selectedItems={selectedItems} onSubmit={onAssign} new={true} />
            </div>
        );

        return (
            <div>
                <DataTable value={auditData} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Unassigned Items"
                     selectionMode={isQCAuditor ? null : 'multiple'}
                    selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header}
                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                    onPage={onPage} first={pageData.index} alwaysShowPaginator={true}
                    totalRecords={tabSummary.Unassigned}
                    scrollable
                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="OpenDate" header="Date Added" sortable filter />
                      {/* {auditPlanType == "Postclose" ?
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />
                        :
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />

                    } */}
                       {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />																			  
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                    <Column field="LoanData.LoanSelection" header="Loan Selection" sortable filter />
                </DataTable>
            </div>
        );


    }

    const CompletedAudits = () => {
        const [loading, setLoading] = useState(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);

        useEffect(() => {

            getAuditData();

        }, []);

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetCompleted${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);
                    let _expandedRows: any = {};
                    setExpandedRows(_expandedRows);
                });

        }

        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);
        const header = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">

                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        );


        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={header} alwaysShowPaginator={false}

                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Date Assigned" sortable filter />
                    <Column field="QC_StartDate" header="Date Started" sortable filter />
                   {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                      {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );


    }

    const QCValidatingAudits = () => {
        const [loading, setLoading] = useState(false);
        const [showConfirm, setShowConfirm] = useState<boolean>(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);
       

        useEffect(() => {

            getAuditData();

        }, []);

        
        const onAssign = () => { 
            getAuditData();
            setSelectedItems([]);
            getTabSummary();
        }

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetValidating${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);
                });

        }

 
        const QCAuditorHeader = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">
                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        )
        const header = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">
                <AssignAudits selectedItems={selectedItems} onSubmit={onAssign} />

                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        );
        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header} alwaysShowPaginator={false}
                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Assigned" sortable filter />
                    <Column field="QC_StartDate" header="QC Started" sortable filter />
                    <Column field="QC_CompleteDate" header="QC Completed" sortable filter />
                     {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                      {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );

    }



    const ValidationCompleteAudits = () => {
        const [loading, setLoading] = useState(false);
        const [showConfirm, setShowConfirm] = useState<boolean>(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);

        const completeItems = () => {

            let param = {

                AuditReviewIds: selectedItems.map(m => m.AuditReviewId)
            }
            authenticatedFetch(
                "/Audit/SetComplete", {
                method: "POST",
                body: JSON.stringify(param),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(res => {
                    var data = res;
                    //refresh data
                    getAuditData();
                    setShowConfirm(false);
                    setSelectedItems([]);
                    getTabSummary();
                    toast.current?.show({ severity: 'success', summary: 'Confirmed', detail: 'Items has been successfully set to Completed', life: 3000 });

                });
        }
        const QCAuditorHeader = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">
                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        )

        const completeActions = (
            <div>
                <Button label="Cancel" icon="pi pi-times" onClick={() => setShowConfirm(false)} className="p-button-text" />
                <Button label="OK" icon="pi pi-check" onClick={() => completeItems()} autoFocus />
            </div>
        );

        const header = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">

                <Button className='smallButton' disabled={selectedItems.length == 0} onClick={() => setShowConfirm(true)}>Set Selected Records to Completed</Button>
                <Dialog header="Complete Items" visible={showConfirm} style={{ width: '400px' }} onHide={() => setShowConfirm(false)} footer={completeActions}>

                    <div className="col-12 mb-2">
                        <label className="block mb-2 text-x">Do you want to set selected audit plans to complete? </label>
                    </div>
                </Dialog>

                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        );
        useEffect(() => {

            getAuditData();

        }, []);

        const getAuditData = () => {

            authenticatedFetch(
                `/Audit/GetValidationComplete${auditPlanType}Audits`)
                .then(res => {
                    var data = res;
                    setAuditData(data);
                });

        }


        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items Being Reviewed"
                    selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={isQCAuditor ? QCAuditorHeader : header} alwaysShowPaginator={false}
                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {isQCAuditor ?
                        <Column headerStyle={{ width: '3rem' }}></Column>
                        :
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                    }
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name"  body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    <Column field="Priority" header="Priority" body={priorityTemplate} sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Assigned" sortable filter />
                    <Column field="QC_StartDate" header="QC Started" sortable filter />
                    <Column field="QC_CompleteDate" header="QC Completed" sortable filter />
                      {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                      {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );
    }

    const AllAudits = () => {
        const [loading, setLoading] = useState(false);
        const [expandedRows, setExpandedRows] = useState<DataTableExpandedRows | DataTableValueArray | undefined>(undefined);
        const [auditData, setAuditData] = useState<any[]>([]);
        const [selectedItems, setSelectedItems] = useState<any[]>([]);

        const [pageData, setPageData] = useState<any>(
            {
                pageSize: 20, index: 0, auditPlanType: auditPlanType
            }
        );

        useEffect(() => {

            getAuditData();

        }, [pageData]);

        const onPage = (event: any) => {
            var param: any = {
                index: event.first,
                pageSize: event.rows,
                auditPlanType: auditPlanType
            }
            setPageData(param);
        };

        const getAuditData = () => {

            var param = pageData;
            authenticatedFetch(
                `/Audit/GetAll${auditPlanType}Audits`, {
                method: "POST",
                body: JSON.stringify(param),
                headers: {
                    "Content-Type": "application/json",
                }
            })
                .then(res => {
                    var data = res;
                    setAuditData(data);
                    let _expandedRows: any = {};
                    setExpandedRows(_expandedRows);
                });

        }

        const header = (
            <div className="table-header flex flex-wrap justify-content-start gap-3">

                <Button icon="pi pi-plus" className='smallButton' label="Expand All Finding" onClick={() => setExpandedRows(toggleFindings(true, auditData))} />
                <Button icon="pi pi-minus" className='smallButton' label="Collapse All Finding" onClick={() => setExpandedRows(toggleFindings(false, auditData))} />

            </div>
        );


        return (
            <div>
                <DataTable value={auditData} sortField="PriorityOrder" sortOrder={1} paginator rows={20} dataKey="AuditReviewId" loading={loading} scrollHeight='56vh' emptyMessage="No Items"
                     selectionMode={isQCAuditor ? null : 'multiple'} selection={selectedItems!} onSelectionChange={(e: any) => setSelectedItems(e.value)}
                    header={header} totalRecords={tabSummary.Total}

                    onPage={onPage} first={pageData.index} alwaysShowPaginator={true} scrollable

                    paginatorTemplate="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown"
                    currentPageReportTemplate="{first} to {last} of {totalRecords}"

                    rowExpansionTemplate={findingTemplate} expandedRows={expandedRows} onRowToggle={(e) => setExpandedRows(e.data)}
                >
                    {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column> */}
                    <Column header="See Findings" expander={allowExpansion} style={{ width: '5rem' }} />
                    <Column field={"LoanData.LoanName" === null ? "Error: Issue 166" : "LoanData.LoanName"} header="Loan Name" body={loanTemplate} sortable filter />
                    {/* <Column field="LoanData.LoanName" header="Loan Name" body={loanTemplate} /> */}
                    <Column field="CurrentStatus" header="Current Status" sortable filter />
                    <Column field={"LoanData.Client" === null ? "" : "LoanData.Client"} header="Client Bank" sortable filter />
                    {/* <Column field="PriorityOrder" header="Priority Order"  /> */}
                    <Column field="QC_AssignedTo" header="QC Assigned To" sortable filter />
                    <Column field="QC_AssignedDate" header="Date Assigned" sortable filter />
                    <Column field="QC_StartDate" header="Date Started" sortable filter />
                    {/* <Column field="LoanData.FundingDate" header="Funding Date" sortable filter /> */}
                          {auditPlanType == "Postclose" &&
                        <Column field="LoanData.ClosingDate" header="Closing Date" sortable filter />}
                        {auditPlanType == "Prefund" &&
                        <Column field="LoanData.FundingDate" header="Funding Date" sortable filter />}
                          {auditPlanType == "Servicing" &&
                        <Column field="LoanData.TransferDate" header="Transfer Date" sortable filter />}
                    <Column field="LoanData.LoanAmount" header="Loan Amount" sortable filter />
                    <Column field="LoanData.LoanType" header="Loan Type" sortable filter />
                    <Column field="LoanData.Investor" header="Investor" sortable filter />
                </DataTable>
            </div>
        );


    }

    const tabHeader = (options: TabPanelHeaderTemplateOptions, header: string, subHeader: string, detail: string) => {
        return (
            <button type="button" onClick={options.onClick} className={options.className} style={{ borderWidth: "0px", marginLeft: "1rem" }}>
                <div className="block font-bold">
                    <Badge value={detail ? detail : 0} className={"mb-2 " + (detail == undefined || detail == '0' ? ' badge-zero-value ' : '')}></Badge><br />{header}<br />
                    {subHeader}

                    {/* {subHeader ? subHeader : '\u00A0'}
                    <div className="block mt-2">{detail} item(s)</div> */}
                </div>
            </button>
        )
    }

    // Security to check if the user has any of the allowed roles.
    // NOTE: Keep below any react.js "use" items (i.e., useHook, useEffect, useState, useMemo, etc.)
    let { hasRoles, isLoading } = useHasRole(['Account Administrator', 'Account Manager', 'QC Admin', 'QC Manager', 'QC Auditor', 'System Administrator','Master Administrator'])

    if (isLoading) {
        return <Loading />
    }
    else if (!hasRoles) {
        return NotFound();
    }

    return (
        <div>
            <Nav />

            <Body>
                <div className='auditTable'>
                    <Toast ref={toast} position="bottom-center" />

                    <h1>{auditPlanType} Audits</h1>
                    <TabView>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "Unassigned", "", tabSummary.Unassigned)}>
                            <UnassignedAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "Currently", "Reviewing", tabSummary.Reviewing)} >
                            <ReviewingAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "QC Complete", "No Finding", tabSummary.QCComplete)}>
                            <QCCompletedAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "QC Complete", "With Findings", tabSummary.QCCompleteFinding)}>
                            <QCCompletedFindingAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "Currently", "Validating", tabSummary.Valdating)}>
                            <QCValidatingAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "Validation", "Complete", tabSummary.ValidationComplete)}>
                            <ValidationCompleteAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "Completed", "", tabSummary.Complete)}>
                            <CompletedAudits />
                        </TabPanel>
                        <TabPanel className="col" headerTemplate={(o) => tabHeader(o, "All", "Plans", tabSummary.Total)}>
                            <AllAudits />
                        </TabPanel>
                    </TabView>
                </div>
            </Body>
        </div>
    )
}